import axios from 'axios'
import { AbstractService } from "./abstract.service";
import { AuthService } from "@/services/auth.service";
import { Message } from 'element-ui'
import FileDownload from "js-file-download";
import moment from "moment";

export class InventoryService extends AbstractService {
  static get entity() {
    return "nsh/inventory/api";
  }

  static get entityIv() {
    return "nsh/odm/api";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }
  
  static get entityInventoryDetail() {
    return "proxy-gateway/gw-core/inventory/item/"
  }

  // danh sách kho get all
  static async inventorylist(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/inventory/list`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  
  // danh sách kho theo quyền user
  static async inventoryListUser(params) {
    try {
      const response = await this.callApi().post(`/n360/mcmnt/api/location/get-locations-has-authority`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // chi tiết kho - tồn kho
  static async inventoryDetail(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/inventory/get-detail`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  // sửa thông tin kho
  static async inventoryUpdate(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/inventory/update`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  //
  static async inventoryItemCheckin(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/inventory-item/checkin`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  //
  static async inventoryItemList(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/inventory-item/search`, params)
      return this.responseWrapper(response, response.data.data, 'success', response.data.meta);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  //
  static async inventoryItemChange(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/inventory-item/change-quantity`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      return this.errorWrapper(error, message);
    }
  }
  // 
  static async creatInventory(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/inventory/create`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-location-id": params.locationId
          }
        }
      )
      return response.data
    } catch (error) {
      console.log(error);
    }
  }
  // danh sách nhập kho
  static async checkinInvetory(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityIv}/order/io/paging-search`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }
  // danh sách chuyển kho
  static async transInventory(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityIv}/order/io/paging-search-transfer`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }
  // danh sách xuất kho
  static async checkoutInventory(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityIv}/order/io/paging-search-checkout`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }
  // chi tiết đơn xuất kho
  static async checkoutDetail(id, params) {
    try {
      const response = await this.callApi().get(
        `${this.URL_GATEWAY}/nsh/odm/api/order/io/${id}`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }
  
  //chi tiết đơn chuyển kho
  static async transDetail(id, params) {
    try {
      const response = await this.callApi().get(
        `${this.URL_GATEWAY}/${this.entityIv}/order/io/${id}`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }

  static async downloadTemplate(){
    try {
     const response = await this.callApi().get(`${this.URL_GATEWAY}/nsh/inventory/api/excel/inventory-data/download-template`)

      FileDownload(response.data, 'Template-inventory' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')

      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }

  static async exportData(inventoryId){
    try {
      const response = await this.callApi().get(`${this.URL_GATEWAY}/nsh/inventory/api/excel/download-inventory-data/${inventoryId}`)

      FileDownload(response.data, 'Export-inventory' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')

      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }

  static async importData(inventoryId, params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/iex/api/inventory-item/upload-data/${inventoryId}`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }

  static async checkFileTimeData(id) {
    try {
      const response = await this.callApi().get(`${this.URL_GATEWAY}/nsh/iex/api/inventory-item/download-data/${id}`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      console.log(error)
      return
    }
  }
    
  static async getRemainingAmount(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/${this.entityInventoryDetail}calculator-remaining-amount`, params
      )
      return this.responseWrapper(response, response.data)
    } catch (error) {
      const message = "Error"
      throw this.errorWrapper(error, message)
    }
  }
  static async itemCompoundsSearch(params) {
    try {
      const response = await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/item/item-compounds/search`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      Message.warning('Máy chủ đang bận. Hãy thử lại sau')
      return
    }
  }
}     
